import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import utils from "../../../Utils/utils"
import * as services from "../services"
import { ADMIN_INVOICES_SLICE_NAME } from "./adminInvoices.constants"

export const getAdminInvoicesFilterOptions = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/get_admin_invoices_filter_options`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminInvoicesFilterOptions()
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminInvoices = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/get_admin_invoices`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminInvoices(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getAdminInvoicesExport = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/get_admin_invoices_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminInvoicesExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateAdminInvoice = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/update_admin_invoice`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.updateAdminInvoice(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Legacy saga routed this through `apiGeneratorBaseWithOnSuccess`: on a bodied success it follows
// `response.data.redirect_url` if present and calls the caller's `onSuccess()` with no arguments;
// on a bodiless 201/204 success it resolves with the request params but does NOT call `onSuccess`.
// Preserved verbatim. Callers no longer pass `onSuccess` in the payload - see
// AdminInvoicesPage/index.js, which strips it and runs it off `.unwrap()` instead.
export const confirmInvoice = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/confirm_invoice`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.confirmInvoice(data)
    if (response.ok && response.data) {
      if (response.data?.redirect_url) utils.goLink(response.data.redirect_url)
      return response.data
    }
    if (response.ok && (response.status === 201 || response.status === 204)) {
      return data
    }
    await handleApiError(dispatch, response)
    return rejectWithValue(response.data)
  }
)

// Same `apiGeneratorBaseWithOnSuccess` shape as `confirmInvoice` above.
export const changeInvoiceAmount = createAsyncThunk(
  `${ADMIN_INVOICES_SLICE_NAME}/change_invoice_amount`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.changeInvoiceAmount(data)
    if (response.ok && response.data) {
      if (response.data?.redirect_url) utils.goLink(response.data.redirect_url)
      return response.data
    }
    if (response.ok && (response.status === 201 || response.status === 204)) {
      return data
    }
    await handleApiError(dispatch, response)
    return rejectWithValue(response.data)
  }
)
